import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var printMq = '@media print';
  return {
    root: {
      position: 'relative',
      alignSelf: 'center'
    },
    overlay: {
      position: 'absolute',
      top: '0',
      left: '0',
      cursor: 'pointer',
      zIndex: componentTheme.overlayZIndex,
      height: '100%',
      width: '100%',
      '&:hover': _defineProperty({
        boxSizing: 'border-box',
        borderLeft: "".concat(componentTheme.overlayBarSize, " solid ").concat(componentTheme.overlayBarColor)
      }, printMq, {
        borderLeft: 'none'
      })
    }
  };
};
export default generateStyle;